import React from 'react';
import BiOption from '@wix/da-bi/pkg/Components/BiOption';
import { isDropdownGroup, findSelectedItem } from '../helpers';
import { useDropdownItems } from '../hooks/useDropdownItems';
var DUMMY_OPTION = {
    selected: true,
    disabled: true,
    hidden: true,
    value: 'null',
    label: '',
};
var NativeDropdown = function (_a) {
    var items = _a.items, onSelect = _a.onSelect, onClick = _a.onClick, className = _a.className, name = _a.name;
    var filteredItems = useDropdownItems(items).filteredItems;
    var selectedItem = findSelectedItem(filteredItems);
    var renderOption = function (_a) {
        var value = _a.value, label = _a.label, hidden = _a.hidden, disabled = _a.disabled, biData = _a.biData;
        return (React.createElement(BiOption, { key: value, hidden: hidden, value: value, disabled: disabled, biData: biData }, label));
    };
    var renderOptGroup = function (_a) {
        var label = _a.label, disabled = _a.disabled, groupItems = _a.items;
        return (React.createElement("optgroup", { key: label, label: label, disabled: disabled }, groupItems.map(renderOption)));
    };
    return (React.createElement("select", { onChange: function (e) { return onSelect(e.target.value, e); }, onClick: onClick, className: className, name: name, value: selectedItem ? selectedItem.value : DUMMY_OPTION.value },
        !selectedItem && renderOption(DUMMY_OPTION),
        filteredItems.map(function (item) {
            return isDropdownGroup(item) ? renderOptGroup(item) : renderOption(item);
        })));
};
NativeDropdown.displayName = 'NativeDropdown';
export default NativeDropdown;
//# sourceMappingURL=NativeDropdown.js.map